
import { Options, Vue } from 'vue-class-component';
import { CourseProduct, Product } from "@/data/products";
import OrderService from "@/services/OrderService";
import { formatPrice } from "@/utils/helpers";
import Alert from "@/components/Alert.vue";
import { EnrollmentCriteriaError } from "@/data/enrollments";
import FieldError from "@/components/forms/FieldError.vue";

@Options({
    props: {
        product: {
            type: Object,
            required: true,
        },
        gatewayId: {
            type: Number,
            required: true,
        },
        additionalOrderData: {
            type: Object,
            required: false,
            default: {},
        },
    },
    components: {
        FieldError,
        Alert,
    },
    emits: {
        success: (value: any) => value === null || typeof value === 'string' || Array.isArray(value),
    },
})
export default class WirePayment extends Vue {
    product!: Product | CourseProduct
    additionalOrderData!: Record<string, any>
    gatewayId!: number

    errorMessage: string | null = null
    loading = false
    showErrors = false

    form = {
        consent_terms: false,
        consent_privacy: false,
    }

    get errors() {
        return {
            consent_terms: !this.form.consent_terms ? ['Bitte akzeptiere die AGB.'] : [],
            consent_privacy: !this.form.consent_privacy ? ['Bitte akzeptiere die Datenschutzerklärung.'] : [],
        };
    }

    get isFormValid() {
        return this.form.consent_terms && this.form.consent_privacy;
    }

    performOrder() {
        this.showErrors = true;

        if (this.loading || !this.isFormValid) {
            return;
        }

        this.loading = true;
        this.errorMessage = null;

        OrderService.orderCreateByProduct(this.gatewayId, this.product, this.additionalOrderData)?.then(result => {
            if (!result.data?.gatewayReference) {
                this.errorMessage = 'Es ist ein Fehler beim Durchführen der Bestellung aufgetreten. Bitte versuche es erneut oder melde dich bei deiner Gebietsleiterin.';
                throw new Error('no gateway reference returned');
            }

            this.$emit('success', [
                'Zahlungsinformationen:',
                'Empfänger: ' + result.data.gatewayPaymentInformation.name,
                'IBAN: ' + result.data.gatewayPaymentInformation.iban,
                'BIC: ' + result.data.gatewayPaymentInformation.bic,
                'Verwendungszweck: ' + result.data.gatewayReference,
                'Summe: ' + formatPrice(result.data.orderAmount),
            ]);
        }).catch(error => {
            const printableEnrollmentErrorMessage = this.getPrintableEnrollmentErrorMessage(error.response.data?.enrollmentErrors as Array<EnrollmentCriteriaError>);
            if (printableEnrollmentErrorMessage) {
                this.errorMessage = 'Es ist ein Fehler beim Durchführen der Bestellung aufgetreten: ' + printableEnrollmentErrorMessage;
            } else {
                this.errorMessage = 'Es ist ein Fehler beim Durchführen der Bestellung aufgetreten. Bitte versuche es erneut oder melde dich bei deiner Gebietsleiterin.';
            }
            console.error(error);
        }).finally(() => this.loading = false);
    }

    getPrintableEnrollmentErrorMessage(errors: Array<EnrollmentCriteriaError>): string {
        return (errors || []).filter(error => ['CourseParticipantsLimitNotReached'].includes(error.key)).map(error => error.errorMessage).join('. ');
    }
}
